import { size } from 'constants/device';
import { APP_ROUTES } from 'constants/routes';

import React from 'react';
import Link from 'next/link';
import { useWindowSize } from 'features/layout/hooks/useWindowSize';
import Title from 'features/layout/components/Cards/common/Title';
import Picture from 'features/layout/components/Cards/common/Picture';
import Customer from 'features/layout/components/Cards/common/Customer';
import Location from 'features/layout/components/Cards/common/Location';
import Description from 'features/layout/components/Cards/common/Description';
import { useFavorite } from 'hooks/useFavorite';
import { stringCapitalized } from 'lib/strings';
import { VacancyTypes } from 'api_entities/vacancies/types';
import placeholder from '../../../../../public/assets/placeholders/placeholder-6.svg';

import type { Props } from './types';
import {
  Container,
  InfoContainer,
  PlaceContainer,
  JobType,
  GroupContainer,
  DetailsContainer,
  CompanyName,
  Employment,
} from './JobCard.styled';

const getHeight = (isMobile: boolean, isHorizontal: boolean): string => {
  if (isHorizontal) return '132px';
  return isMobile ? '90px' : '190px';
};
const CARD_URL_BY_TYPE: Record<string, string> = {
  [VacancyTypes.job]: APP_ROUTES.ALL_VACANCIES,
};

// TODO Finish horizontal style

export const JobCard = ({
  city,
  company,
  img,
  photoURL,
  title,
  horizontal,
  employment,
  description,
  objectID,
  type,
  slug,
  vacancyType,
}: Props) => {
  const [isFavorite, onFavoriteClick] = useFavorite('job', objectID);
  const { width } = useWindowSize();
  const isMobile = width < size.tablet;
  const vacancyTypeUrl =
    CARD_URL_BY_TYPE[vacancyType] || CARD_URL_BY_TYPE[employment] || APP_ROUTES.ALL_VACANCIES;

  return (
    <Link href={`${vacancyTypeUrl}/${slug}`} passHref>
      <a>
        <Container horizontal={horizontal}>
          <Picture
            src={img || photoURL || placeholder}
            height={getHeight(isMobile, horizontal)}
            width={horizontal ? '132px' : '100%'}
            fit="contain"
            alt="Job"
            isFavorite={isFavorite}
            onFavoriteClick={onFavoriteClick}
            loading="lazy"
            fallBackSRC={placeholder}
          />
          <InfoContainer horizontal={horizontal}>
            <div>
              <Title maxLineCount={1}>{title}</Title>
              {horizontal && description && <Description content={description} maxLineCount={2} />}
            </div>
            <div>
              {!horizontal && (
                <PlaceContainer>
                  <Customer title={company?.title} src={company?.logoURL} />
                  <Location name={city} />
                </PlaceContainer>
              )}
              {horizontal && (
                <DetailsContainer horizontal={horizontal}>
                  <GroupContainer horizontal={horizontal}>
                    {horizontal && company && <CompanyName>{company?.title || 'N/A'}</CompanyName>}
                    {horizontal && <Employment>{stringCapitalized(employment)}</Employment>}
                  </GroupContainer>
                  <Location name={city} />
                </DetailsContainer>
              )}

              {!horizontal && <JobType>{type}</JobType>}
            </div>
          </InfoContainer>
        </Container>
      </a>
    </Link>
  );
};

JobCard.defaultProps = {
  horizontal: false,
};
